//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'SettingsThemeImage',
  props: {
    dark: {
      type: Boolean,
      default: false
    },
    showTransparencyGrid: {
      type: Boolean,
      default: false
    },
    imgSrc: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      lightIconBg: '#00000066',
      darkIconBg: '#FFFFFF66'
    };
  },
  methods: {
    getAspectRatio: function getAspectRatio(width, height) {
      var factor = width / height;
      var threshold = 0.2;

      if (factor < 1 - threshold) {
        return 'portrait';
      } else if (factor > 1 + threshold) {
        return 'landscape';
      }

      return 'square';
    },
    handleImageAdded: function handleImageAdded(event) {
      var input = event.target;

      if (input.files && input.files[0]) {
        this.updateImageThumbnail(input.files[0]);
      }
    },
    addImage: function addImage() {
      this.$refs['fileInput'].click();
    },
    resetThumbnail: function resetThumbnail() {
      this.$refs['imageElement'].src = this.imgSrc;
    },
    updateImageThumbnail: function updateImageThumbnail(file) {
      var _this = this;

      var reader = new FileReader();
      var imageRef = this.$refs['imageElement'];

      reader.onload = function (e) {
        imageRef.src = e.target.result; // NOTE: move to img.onLoad ?
        // have to wait for image loaded into img element to get current width & height

        _this.$nextTick(function () {
          var orientation = _this.getAspectRatio(imageRef.width, imageRef.height);

          _this.$emit('image:update', file, orientation);
        });
      };

      reader.readAsDataURL(file);
    }
  }
};